module.exports = __webpack_public_path__ + "img/chores.b307dac0.svg";